import { WidgetContainer } from '../WidgetContainer';
import styles from './PlaceholderWidget.module.scss';

export interface PlaceholderWidgetProps {
    title: string;
    description?: string;
}

export function PlaceholderWidget({ title, description }: PlaceholderWidgetProps) {
    return (
        <WidgetContainer
            title={title}
            description={description}
            isEmpty={false}
            size="medium"
        >
            <div className={styles.placeholder}>
                <div className={styles.placeholder__content}>
                    <span className={styles.placeholder__icon}>🚧</span>
                    <h3 className={styles.placeholder__title}>Coming Soon</h3>
                    <p className={styles.placeholder__text}>
                        This analytic is currently under construction.
                    </p>
                </div>
            </div>
        </WidgetContainer>
    );
}
